var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#page-error{position:fixed;top:0;left:0;right:0;bottom:0;background:url(" + escape(require("../../assets/images/404.jpg")) + ") top no-repeat;background-size:cover}", ""]);

// exports
